import { v5 as uuidv5 } from 'uuid'

/**
 * Deterministic UUIDv5 id for a private per-user Space order row.
 *
 * ID GENERATION CHOICE — UUIDv5 over "workspaceId:userId:projectId", not SHA-256→UUID.
 * UUIDv5 already has a cross-stack implementation in this codebase (see systemTabIds.ts
 * and its backend twin) that is byte-compatible with Postgres `uuid_generate_v5`, so
 * web, mobile and the API agree without a bespoke hash-to-UUID step.
 *
 * Why deterministic: two devices reordering Spaces offline must converge on the same
 * row for the same (workspace, user, space) triple instead of racing to insert two ids
 * behind the backend's filtered unique index `ix_user_project_orders_unique`.
 *
 * The same namespace UUID and name format are duplicated in the backend
 * (moly-platform/src/Moly/Domain/Constants/SpaceOrderIds.cs); both must produce
 * byte-identical UUIDs for any given triple — verified by SpaceOrderIdsTests.cs and
 * spaceOrderId.test.ts pinning the same expected values. Mobile has no copy because
 * its v1 ordering is read-only; add one there alongside a mobile reorder gesture.
 */
export const SPACE_ORDER_NAMESPACE = '9b6c1f4e-2a7d-4c58-8f31-6d0e5a9b3c27'

export const spaceOrderId = (
  envId: string,
  userId: string,
  projectId: string,
): string => uuidv5(`${envId}:${userId}:${projectId}`, SPACE_ORDER_NAMESPACE)
